module.exports = __webpack_public_path__ + "img/ToolRental.e6fa032d.jpeg";